import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba2d583a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello-banner" }
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = {
  class: "section",
  ref: "section1"
}
const _hoisted_4 = { class: "section-top" }
const _hoisted_5 = { class: "section-name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_7 = { class: "section-body" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "data-row" }
const _hoisted_10 = { class: "row-label" }
const _hoisted_11 = { class: "row-content" }
const _hoisted_12 = { class: "row-button" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = { class: "data-row" }
const _hoisted_16 = { class: "row-label" }
const _hoisted_17 = { class: "row-content" }
const _hoisted_18 = { class: "row-button" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = { class: "data-row" }
const _hoisted_22 = { class: "row-label" }
const _hoisted_23 = { class: "row-content" }
const _hoisted_24 = { class: "row-button" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_26 = { class: "data-row" }
const _hoisted_27 = { class: "row-label" }
const _hoisted_28 = { class: "row-content" }
const _hoisted_29 = { class: "row-button" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_31 = { class: "data-row" }
const _hoisted_32 = { class: "row-label" }
const _hoisted_33 = { class: "row-content" }
const _hoisted_34 = {
  key: 0,
  class: "data-row change-email-area"
}
const _hoisted_35 = { class: "row-label" }
const _hoisted_36 = { class: "row-content" }
const _hoisted_37 = {
  key: 0,
  class: "email-btn-group"
}
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "option-menu-wrapper" }
const _hoisted_40 = {
  key: 0,
  class: "menu-options"
}
const _hoisted_41 = { class: "option" }
const _hoisted_42 = { class: "option mt-2" }
const _hoisted_43 = { class: "data-row last-row" }
const _hoisted_44 = { class: "row-label" }
const _hoisted_45 = { class: "row-content" }
const _hoisted_46 = { class: "chip-content" }
const _hoisted_47 = {
  class: "section",
  ref: "section2"
}
const _hoisted_48 = { class: "section-top" }
const _hoisted_49 = { class: "section-name" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_51 = { class: "section-body" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_55 = { class: "data-row user-row" }
const _hoisted_56 = { class: "row-content second-col" }
const _hoisted_57 = { class: "group-name" }
const _hoisted_58 = { class: "group-describe" }
const _hoisted_59 = { class: "row-button" }
const _hoisted_60 = {
  key: 0,
  class: "thin-divider"
}
const _hoisted_61 = {
  class: "section",
  ref: "section3"
}
const _hoisted_62 = { class: "section-top" }
const _hoisted_63 = { class: "section-name" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_65 = { class: "section-body" }
const _hoisted_66 = { class: "data-row" }
const _hoisted_67 = { class: "row-label" }
const _hoisted_68 = { class: "row-content" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "password-hide" }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "row-button" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_76 = { class: "data-row" }
const _hoisted_77 = { class: "row-label" }
const _hoisted_78 = { class: "row-content" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "row-button" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_83 = { class: "data-row xid-button-row" }
const _hoisted_84 = { class: "row-label" }
const _hoisted_85 = { class: "row-content" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = {
  key: 0,
  class: "xid-intro"
}
const _hoisted_89 = ["innerHTML"]
const _hoisted_90 = { class: "icon-row mt-4" }
const _hoisted_91 = ["src"]
const _hoisted_92 = ["src"]
const _hoisted_93 = {
  class: "section",
  ref: "section5"
}
const _hoisted_94 = { class: "section-top" }
const _hoisted_95 = { class: "section-name" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_97 = { class: "section-body" }
const _hoisted_98 = { class: "data-row user-row" }
const _hoisted_99 = ["src"]
const _hoisted_100 = { class: "row-content second-col" }
const _hoisted_101 = { class: "group-name" }
const _hoisted_102 = { class: "group-describe" }
const _hoisted_103 = {
  key: 0,
  class: "thin-divider"
}
const _hoisted_104 = { class: "section-side" }
const _hoisted_105 = { class: "w-full section-footer" }
const _hoisted_106 = { class: "popup-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bread_scrum = _resolveComponent("bread-scrum")!
  const _component_AvatarCircle = _resolveComponent("AvatarCircle")!
  const _component_TextButton = _resolveComponent("TextButton")!
  const _component_menu_option_dropdown = _resolveComponent("menu-option-dropdown")!
  const _component_Vue3Popper = _resolveComponent("Vue3Popper")!
  const _component_text_button = _resolveComponent("text-button")!
  const _component_toggle_checkbox = _resolveComponent("toggle-checkbox")!
  const _component_XIDButton = _resolveComponent("XIDButton")!
  const _component_AfterLoginPageLayout = _resolveComponent("AfterLoginPageLayout")!
  const _component_TableSelect = _resolveComponent("TableSelect")!
  const _component_flat_button = _resolveComponent("flat-button")!
  const _component_popup = _resolveComponent("popup")!
  const _component_two_factor_qr = _resolveComponent("two-factor-qr")!
  const _component_UpdateAvatarPopup = _resolveComponent("UpdateAvatarPopup")!
  const _component_update_info_popup = _resolveComponent("update-info-popup")!
  const _component_update_password_popup = _resolveComponent("update-password-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AfterLoginPageLayout, {
      class: "account-detail",
      "is-sub-header-menu": false,
      "right-part-popup": false,
      "none-padding-top": true
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_bread_scrum, { paths: _ctx.breadscrumLinks }, null, 8, ["paths"])
        ])
      ]),
      topLeft: _withCtx(() => []),
      bottomLeft: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("accountDetail.section1")), 1)
              ]),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("accountDetail.avatar")), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_AvatarCircle, {
                      avatar: 
                      _ctx.accountInfo.avatar && _ctx.accountInfo.avatar != 'default'
                        ? _ctx.getFilePathFromUrl(_ctx.accountInfo.avatar)
                        : _ctx.defaultAvatar
                    ,
                      class: "avatar"
                    }, null, 8, ["avatar"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_TextButton, {
                        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEditPopup(_ctx.editPopupList.UPDATE_LOGO))),
                        "is-show-text": !_ctx.isMobile,
                        icon: require('icons/edit.svg'),
                        text: _ctx.$t('accountDetail.editButton')
                      }, null, 8, ["is-show-text", "icon", "text"])
                    ])
                  ])
                ]),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("accountDetail.username")), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.accountInfo.fullName), 1),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_TextButton, {
                        onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditPopup(_ctx.editPopupList.UPDATE_NAME))),
                        icon: require('icons/edit.svg'),
                        "is-show-text": !_ctx.isMobile,
                        text: _ctx.$t('accountDetail.editButton')
                      }, null, 8, ["icon", "is-show-text", "text"])
                    ])
                  ])
                ]),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("accountDetail.role")), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.profile.position), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_TextButton, {
                        onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEditPopup(_ctx.editPopupList.UPDATE_POSITION))),
                        icon: require('icons/edit.svg'),
                        "is-show-text": !_ctx.isMobile,
                        text: _ctx.$t('accountDetail.editButton')
                      }, null, 8, ["icon", "is-show-text", "text"])
                    ])
                  ])
                ]),
                _hoisted_25
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("accountDetail.phone")), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.profile.phoneNumber), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_TextButton, {
                        onOnClick: _cache[3] || (_cache[3] = ($event: any) => (
                        _ctx.showEditPopup(_ctx.editPopupList.UPDATE_PHONE_NUMBER)
                      )),
                        icon: require('icons/edit.svg'),
                        "is-show-text": !_ctx.isMobile,
                        text: _ctx.$t('accountDetail.editButton')
                      }, null, 8, ["icon", "is-show-text", "text"])
                    ])
                  ])
                ]),
                _hoisted_30
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("accountDetail.mail")), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.profile.email), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_TextButton, {
                        onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showEditPopup(_ctx.editPopupList.UPDATE_EMAIL))),
                        icon: require('icons/edit.svg'),
                        "is-show-text": !_ctx.isMobile,
                        text: _ctx.$t('accountDetail.editButton')
                      }, null, 8, ["icon", "is-show-text", "text"])
                    ])
                  ])
                ]),
                (_ctx.profile.emailPending)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t("accountDetail.newEmail")), 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.profile.emailPending), 1),
                        (!_ctx.isMobile)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createVNode(_component_TextButton, {
                                onOnClick: _ctx.resendPendingEmailClick,
                                icon: require('icons/re-invite.svg'),
                                "is-show-text": !_ctx.isMobile,
                                text: _ctx.$t('accountDetail.resendEmail')
                              }, null, 8, ["onOnClick", "icon", "is-show-text", "text"]),
                              _createVNode(_component_TextButton, {
                                onOnClick: _ctx.cancelPendingEmail,
                                icon: require('icons/cancel.svg'),
                                "is-show-text": !_ctx.isMobile,
                                text: _ctx.$t('accountDetail.cancelChange'),
                                class: "mt-2 delete"
                              }, null, 8, ["onOnClick", "icon", "is-show-text", "text"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              (_ctx.isMobile)
                                ? (_openBlock(), _createBlock(_component_TextButton, {
                                    key: 0,
                                    icon: require('icons/more.svg'),
                                    onOnClick: _cache[5] || (_cache[5] = ($event: any) => (!_ctx.showEmailOption))
                                  }, null, 8, ["icon"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_39, [
                                (_ctx.showEmailOption == true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      _createVNode(_component_menu_option_dropdown, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_41, [
                                            _createVNode(_component_TextButton, {
                                              onOnClick: _cache[6] || (_cache[6] = ($event: any) => (
                                _ctx.showEditPopup(_ctx.editPopupList.UPDATE_EMAIL)
                              )),
                                              icon: require('icons/re-invite.svg'),
                                              text: _ctx.$t('accountDetail.resendEmail')
                                            }, null, 8, ["icon", "text"])
                                          ]),
                                          _createElementVNode("div", _hoisted_42, [
                                            _createVNode(_component_TextButton, {
                                              onOnClick: _ctx.showHidePopup,
                                              icon: require('icons/cancel.svg'),
                                              text: _ctx.$t('accountDetail.cancelChange')
                                            }, null, 8, ["onOnClick", "icon", "text"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'mt-1': _ctx.editEmailState != 1 }, "thin-divider"])
                }, null, 2)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("accountDetail.permission")), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.profile.roleName), 1)
                    ])
                  ])
                ])
              ])
            ])
          ], 512),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t("accountDetail.section2")), 1),
                _createVNode(_component_TextButton, {
                  onOnClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAddAuthPopup = true)),
                  "is-show-text": !_ctx.isMobile,
                  text: _ctx.$t('accountDetail.addUserButton'),
                  icon: require('icons/add.svg'),
                  class: "primary"
                }, null, 8, ["is-show-text", "text", "icon"])
              ]),
              _hoisted_50
            ]),
            _createElementVNode("div", _hoisted_51, [
              (_ctx.userApproversLength === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("p", {
                      innerHTML: _ctx.$t('accountDetail.emptyApprover'),
                      class: "empty-user"
                    }, null, 8, _hoisted_53),
                    _hoisted_54
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.userApprovers, (user, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_AvatarCircle, {
                          class: "user-icon",
                          avatar: 
                    user.profilePicture
                      ? _ctx.getFilePathFromUrl(user.profilePicture)
                      : require('icons/default-avatar.svg')
                  ,
                          alt: "avatar"
                        }, null, 8, ["avatar"]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_57, _toDisplayString(user.lastName + " " + user.firstName), 1),
                            _createVNode(_component_Vue3Popper, {
                              content: user.email
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_58, _toDisplayString(user.email), 1)
                              ]),
                              _: 2
                            }, 1032, ["content"])
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_TextButton, {
                              onOnClick: ($event: any) => (_ctx.deleteApprover(user)),
                              text: _ctx.$t('accountDetail.deleteAuthButton'),
                              "is-show-text": !_ctx.isMobile,
                              icon: require('icons/delete.svg'),
                              class: "delete"
                            }, null, 8, ["onOnClick", "text", "is-show-text", "icon"])
                          ])
                        ])
                      ]),
                      (index != _ctx.userApprovers.length - 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
            ])
          ], 512),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t("accountDetail.section3")), 1)
              ]),
              _hoisted_64
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t("accountDetail.password")), 1),
                  _createElementVNode("div", _hoisted_68, [
                    (!_ctx.profile.noPassword)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                              return _createElementVNode("div", {
                                key: i,
                                class: "dot"
                              })
                            }), 64))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_73)),
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_text_button, {
                        onOnClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showEditPopup(_ctx.editPopupList.UPDATE_PASSWORD))),
                        icon: require('icons/edit.svg'),
                        "is-show-text": !_ctx.isMobile,
                        text: _ctx.$t('memberProfile.buttonEdit')
                      }, null, 8, ["icon", "is-show-text", "text"])
                    ])
                  ])
                ]),
                _hoisted_75
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("p", _hoisted_77, _toDisplayString(_ctx.$t("accountDetail.authTwoFactor")), 1),
                  _createElementVNode("div", _hoisted_78, [
                    (_ctx.showAuthTwoFactor || _ctx.profile.totpTurnedOn)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString(_ctx.$t("accountDetail.on")), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_80, _toDisplayString(_ctx.$t("accountDetail.off")), 1)),
                    _createElementVNode("div", _hoisted_81, [
                      _createVNode(_component_toggle_checkbox, {
                        style: {"line-height":"20px"},
                        checked: _ctx.showAuthTwoFactor || _ctx.profile.totpTurnedOn,
                        onOnChange: _ctx.showTwoFactorAuth,
                        "onUpdate:checked": _ctx.updateShowTwoFactorAuth
                      }, null, 8, ["checked", "onOnChange", "onUpdate:checked"])
                    ])
                  ])
                ]),
                _hoisted_82
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("p", _hoisted_84, _toDisplayString(_ctx.$t("accountDetail.useXID")), 1),
                  _createElementVNode("div", _hoisted_85, [
                    (_ctx.profile.hasXID == true)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(_ctx.$t("accountDetail.on")), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(_ctx.$t("accountDetail.off")), 1))
                  ]),
                  (_ctx.profile.hasXID == false)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass({ 'w-full mt-1': _ctx.isMobile })
                      }, [
                        _createVNode(_component_XIDButton, {
                          text: _ctx.$t('accountDetail.XIDButton'),
                          class: "xid-button",
                          onClick: _ctx.onClickLinkXIDAccount
                        }, null, 8, ["text", "onClick"])
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.profile.hasXID == false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                      _createElementVNode("p", {
                        class: "describe",
                        innerHTML: _ctx.$t('accountDetail.XIDDescribe')
                      }, null, 8, _hoisted_89),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("img", {
                          class: "mr-4 open-store-logo",
                          src: require('images/app-store.svg'),
                          alt: "App Store Icon",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (
                      _ctx.openURL('https://apps.apple.com/jp/app/xid/id1495147544')
                    ))
                        }, null, 8, _hoisted_91),
                        _createElementVNode("img", {
                          class: "open-store-logo",
                          src: require('images/play-store.svg'),
                          alt: "Play Store Icon",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (
                      _ctx.openURL(
                        'https://play.google.com/store/apps/details?id=me.x.id'
                      )
                    ))
                        }, null, 8, _hoisted_92)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 512),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("p", _hoisted_95, _toDisplayString(_ctx.$t("accountDetail.section5")), 1)
              ]),
              _hoisted_96
            ]),
            _createElementVNode("div", _hoisted_97, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("img", {
                      src: require('icons/primary-view.svg'),
                      alt: "icon",
                      class: "user-icon"
                    }, null, 8, _hoisted_99),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_101, _toDisplayString(group.name), 1),
                        _createElementVNode("p", _hoisted_102, _toDisplayString(group.description), 1)
                      ])
                    ])
                  ]),
                  (index != _ctx.groups.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ], 512)
        ])
      ]),
      bottomRight: _withCtx(() => [
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("div", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.scrollToSection('section1'))),
            class: _normalizeClass(["side-tile", { 'on-chosen': _ctx.currentSection === 'section1' }])
          }, [
            _createElementVNode("button", null, _toDisplayString(_ctx.$t("accountDetail.section1")), 1)
          ], 2),
          _createElementVNode("div", {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.scrollToSection('section2'))),
            class: _normalizeClass(["side-tile mt-1", { 'on-chosen': _ctx.currentSection === 'section2' }])
          }, [
            _createElementVNode("button", null, _toDisplayString(_ctx.$t("accountDetail.section2")), 1)
          ], 2),
          _createElementVNode("div", {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.scrollToSection('section3'))),
            class: _normalizeClass(["side-tile mt-1", { 'on-chosen': _ctx.currentSection === 'section3' }])
          }, [
            _createElementVNode("button", null, _toDisplayString(_ctx.$t("accountDetail.section3")), 1)
          ], 2),
          _createElementVNode("div", {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.scrollToSection('section5'))),
            class: _normalizeClass(["side-tile mt-1", { 'on-chosen': _ctx.currentSection === 'section5' }])
          }, [
            _createElementVNode("button", null, _toDisplayString(_ctx.$t("accountDetail.section5")), 1)
          ], 2)
        ])
      ]),
      _: 1
    }),
    (_ctx.showAddAuthPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          title: _ctx.$t('accountDetail.addAuthPopupTitle'),
          onOnClickOutsidePopup: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showAddAuthPopup = false)),
          onOnHide: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showAddAuthPopup = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "popup-container",
              style: _normalizeStyle({ 'padding-bottom': _ctx.isOverflow ? '20px' : '4px' }),
              onScroll: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
            }, [
              _createVNode(_component_TableSelect, {
                selectedValues: _ctx.userApprovers,
                items: _ctx.addApproversList,
                label: !_ctx.isMobile ? _ctx.$t('accountDetail.addAuthLabel') : '',
                "limit-number": 5,
                limit: true,
                "search-hint": _ctx.$t('accountDetail.addAuthSearchHint'),
                onOnUpdate: _ctx.updateSelectedApprover,
                onOnInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.approverSearch($event)))
              }, null, 8, ["selectedValues", "items", "label", "search-hint", "onOnUpdate"])
            ], 36),
            _createElementVNode("div", _hoisted_105, [
              _createVNode(_component_flat_button, {
                class: "add-btn",
                onOnClick: _ctx.addUserApprovers,
                text: _ctx.$t('accountDetail.addAuthButton')
              }, null, 8, ["onOnClick", "text"])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.showAuthTwoFactor)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          title: _ctx.$t('accountDetail.authTwoFactor'),
          onOnClickOutsidePopup: _ctx.onTurnOffTwoFactor,
          onOnHide: _ctx.onTurnOffTwoFactor,
          class: "authTwoPopup"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_106, [
              _createVNode(_component_two_factor_qr, {
                secret: _ctx.totpSecret,
                "qr-image": _ctx.qrCode,
                "verify-method": _ctx.verifyTOTPSecret,
                onOnSuccess: _ctx.onSuccessAuthTwoFactor
              }, null, 8, ["secret", "qr-image", "verify-method", "onOnSuccess"])
            ])
          ]),
          _: 1
        }, 8, ["title", "onOnClickOutsidePopup", "onOnHide"]))
      : _createCommentVNode("", true),
    (_ctx.selectedEditPopup === _ctx.editPopupList.UPDATE_LOGO)
      ? (_openBlock(), _createBlock(_component_UpdateAvatarPopup, {
          key: 2,
          "show-popup": _ctx.showPopup,
          avatar: _ctx.accountInfo.avatar,
          "selected-edit-popup": _ctx.selectedEditPopup,
          "edit-popup-list": _ctx.editPopupList,
          id: _ctx.profile.id,
          "is-account": true,
          name: "updateLogoPopup",
          onHideEditPopup: _ctx.hideEditPopup,
          onHandleSubmitChangeField: _ctx.handleSubmitChangeField
        }, null, 8, ["show-popup", "avatar", "selected-edit-popup", "edit-popup-list", "id", "onHideEditPopup", "onHandleSubmitChangeField"]))
      : (_ctx.selectedEditPopup === _ctx.editPopupList.UPDATE_NAME)
        ? (_openBlock(), _createBlock(_component_update_info_popup, {
            key: 3,
            "show-popup": _ctx.showPopup,
            title: _ctx.$t('accountDetail.editName'),
            name: "updateNamePopup",
            id: _ctx.profile.id,
            "is-account": true,
            "first-name": _ctx.profile.firstName,
            "last-name": _ctx.profile.lastName,
            "popup-list-index": _ctx.editPopupList.UPDATE_NAME,
            onHideEditPopup: _ctx.hideEditPopup,
            onHandleSubmitChangeField: _ctx.handleSubmitChangeField
          }, null, 8, ["show-popup", "title", "id", "first-name", "last-name", "popup-list-index", "onHideEditPopup", "onHandleSubmitChangeField"]))
        : (_ctx.selectedEditPopup === _ctx.editPopupList.UPDATE_POSITION)
          ? (_openBlock(), _createBlock(_component_update_info_popup, {
              key: 4,
              "show-popup": _ctx.showPopup,
              title: _ctx.$t('accountDetail.editPosition'),
              id: _ctx.profile.id,
              "is-account": true,
              position: _ctx.profile.position,
              "popup-list-index": _ctx.editPopupList.UPDATE_POSITION,
              onHideEditPopup: _ctx.hideEditPopup,
              onHandleSubmitChangeField: _ctx.handleSubmitChangeField
            }, null, 8, ["show-popup", "title", "id", "position", "popup-list-index", "onHideEditPopup", "onHandleSubmitChangeField"]))
          : (_ctx.selectedEditPopup === _ctx.editPopupList.UPDATE_PHONE_NUMBER)
            ? (_openBlock(), _createBlock(_component_update_info_popup, {
                key: 5,
                "show-popup": _ctx.showPopup,
                title: _ctx.$t('accountDetail.editPhoneNumber'),
                id: _ctx.profile.id,
                "is-account": true,
                "phone-number": _ctx.profile.phoneNumber,
                "popup-list-index": _ctx.editPopupList.UPDATE_PHONE_NUMBER,
                onHideEditPopup: _ctx.hideEditPopup,
                onHandleSubmitChangeField: _ctx.handleSubmitChangeField
              }, null, 8, ["show-popup", "title", "id", "phone-number", "popup-list-index", "onHideEditPopup", "onHandleSubmitChangeField"]))
            : (_ctx.selectedEditPopup === _ctx.editPopupList.UPDATE_EMAIL)
              ? (_openBlock(), _createBlock(_component_update_info_popup, {
                  key: 6,
                  "show-popup": _ctx.showPopup,
                  title: _ctx.$t('accountDetail.editEmail'),
                  id: _ctx.profile.id,
                  "is-account": true,
                  email: _ctx.profile.email,
                  "popup-list-index": _ctx.editPopupList.UPDATE_EMAIL,
                  onHideEditPopup: _ctx.hideEditPopup,
                  onHandleSubmitChangeField: _ctx.handleSubmitChangeField
                }, null, 8, ["show-popup", "title", "id", "email", "popup-list-index", "onHideEditPopup", "onHandleSubmitChangeField"]))
              : (_ctx.selectedEditPopup === _ctx.editPopupList.UPDATE_PASSWORD)
                ? (_openBlock(), _createBlock(_component_update_password_popup, {
                    key: 7,
                    "show-popup": _ctx.showPopup,
                    title: _ctx.$t('accountDetail.changePassword'),
                    id: _ctx.profile.id,
                    "is-account": true,
                    "no-password": _ctx.profile.noPassword,
                    onHideEditPopup: _ctx.hideEditPopup,
                    onHandleSubmitChangeField: _ctx.handleSubmitChangeField
                  }, null, 8, ["show-popup", "title", "id", "no-password", "onHideEditPopup", "onHandleSubmitChangeField"]))
                : _createCommentVNode("", true)
  ], 64))
}